export const T = {
  en_GB: {
    saveFailed: "Failed to save your answer. Please try again.",
  },
  nb_NO: {
    saveFailed: "Kunne ikke lagre svaret ditt. Vennligst prøv igjen.",
  },
} as const;
